module.exports = __webpack_public_path__ + "img/btn-open.27b04b11.webp";